<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"></CommonBreadCrumbs>
    <div>
      <NuxtLayout name="center">
        <div class="text-start sm:text-center mx-auto mt-4 pb-12 md:pb-24 w-full md:w-[77%]">
          <h1 class="mb-7 font-semibold text-[1.875rem] md:text-[2.625rem]">
            {{ title }}
          </h1>
          <p class="flex justify-center sm:text-center text-lg">
            {{ aboutUsDescription }}
          </p>
        </div>
      </NuxtLayout>
      <div class="bg-[#F0FBFB] pb-8 md:pb-0 pt-3 relative overflow-hidden">
        <AboutWorldMap :isTop="true"></AboutWorldMap>
        <NuxtLayout v-if="!pending" name="center" class="md:relative">
          <AboutStats :aboutUsRes="aboutUsRes" />
        </NuxtLayout>
        <div class="absolute left-0 bottom-0 bg-white w-full h-28"></div>
      </div>
      <div
        class="flex bg-white h-16 md:h-28 justify-center items-center relative bottom-[62px] md:bottom-[112px] md:-mb-36 hidden"
        v-if="aboutUsRes.data.team_members.length > 0"
      >
        <NuxtLink :to="localeHomePath(switchBlogLocale())">
          <button
            class="border rounded text-center top-16 relative border-secondary text-secondary whitespace-nowrap bg-white h-[38px] w-[277px] text-lg font-bold md:top-4 hover:bg-secondary hover:text-white"
          >
            {{ $t("aboutUs.meetOurTeamBtn") }}
          </button>
        </NuxtLink>
      </div>
      <div class="bg-secondary-lighter">
        <NuxtLayout name="center">
          <section class="what-we-do md:pt-8" v-html="whatWedoBody"></section>
        </NuxtLayout>
        <div class="flex mt-8">
          <div class="flex flex-col gap-8 md:gap-10 w-full md:mx-auto">
            <AboutCommentContentBlock
              v-for="(content_block, index) in partners"
              :key="index"
              :contentData="content_block"
              :index="index"
            />
          </div>
        </div>
      </div>
      <div class="bg-white">
        <NuxtLayout name="center" :mobilePadding="false">
          <ProductReview
            class="md:mt-8 md:mb-28 bg-white pt-16"
            :reviewList="reviewResult.data"
            :totalReview="reviewResult.meta"
            totalReviewPosition="top"
          />
        </NuxtLayout>
        <!--
        <div class="pb-4 bg-stone-white pt-4">
          <NuxtLayout name="center">
            <div class="max-w-md md:mx-auto md:max-w-screen-xl justify-center">
              <div
                class="grid grid-cols-1 gap-4 mt-8 md:my-12 items-baseline justify-evenly md:grid-cols-3 md:space-y-0 md:gap-8 md:mt-12 md:justify-items-center md:gap-x-24"
              >
                <AboutCardQualities />
              </div>
            </div>
          </NuxtLayout>
        </div>
        -->
      </div>
    </div>
  </div>
</template>
<script setup>
const { data: reviewResult } = await useBlockReview(1);
let aboutUsDescription = ref("");
let title = ref("");
let whatWedoBody = ref("");
let partners = ref([]);

const { data: aboutUsRes, pending } = await useAboutUs();

if (!pending.value) {
  aboutUsDescription = aboutUsRes.value.data.intro_text;
  title = aboutUsRes.value.data.title;
  whatWedoBody = aboutUsRes.value.data.content_blocks_text;
  whatWedoBody = whatWedoBody
    .replace(/<p>/g, "<p class='font-semibold md:mb-8 text-lg md:w-full text-[#253754F2]'>")
    .replace(/<h3>/g, "<h2 class='mb-8 font-bold mt-12 md:mt-16'>");
  partners = aboutUsRes.value.data.content_blocks;
}

useMetaTitles(aboutUsRes.value.data, "about-us");

const breadcrumbs = getBreadcrumbs("about-us");
</script>

<style scoped>
.what-we-do {
  @apply text-center flex flex-col max-w-[350px] mx-auto md:max-w-[831px];
}
</style>
